"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.start.recording': 'Iniciar Grabación',
    'conversation.start.failed': 'No se pudo iniciar la conversación',
};
